import { useDebouncedValue } from "@mantine/hooks";
import { useEffect, useState } from "react";

import { SearchTruck, useLazySearchTrucksQuery } from "@/store";

export type UseSearchTrucksParams = {
  search?: string;
  getValue?: (truck: SearchTruck) => string;
  getLabel?: (truck: SearchTruck) => string;
};
export function useSearchTrucks({ search = "", getValue, getLabel }: UseSearchTrucksParams = {}) {
  const [searchTruck, setSearchTruck] = useState(search);
  const [debouncedSearchTruck] = useDebouncedValue(searchTruck, 300);
  const [searchTrucks, { data: trucks, ...state }] = useLazySearchTrucksQuery({
    selectFromResult: (state) => ({
      ...state,
      data: {
        options:
          state.data?.map((truck) => ({
            value: getValue?.(truck) || String(truck.id),
            label: getLabel?.(truck) || truck.licensePlate
          })) || [],
        result: state.data || []
      }
    })
  });

  useEffect(() => {
    if (debouncedSearchTruck.trim().length) {
      searchTrucks({ licensePlate: debouncedSearchTruck });
    }
  }, [debouncedSearchTruck, search]);

  return {
    data: trucks,
    actions: {
      setSearchTruck
    },
    state: {
      searchTruck,
      debouncedSearchTruck,
      ...state
    }
  };
}
